import { GeoSearchControl, OpenStreetMapProvider } from "leaflet-geosearch";
import { useEffect } from "react";
import { useMap } from "react-leaflet";

function GeoSearchBar({ setMarkerPosition }) {
    
  const map = useMap();
  useEffect(() => {
    const provider = new OpenStreetMapProvider();
    const searchControl = new GeoSearchControl({
      provider,
      style: 'bar',
      showMarker: false,
      showPopup: false,
      autoClose: true,
      retainZoomLevel: false,
      animateZoom: true,
      keepResult: true,
      searchLabel: 'Enter location...',
    });

    map.addControl(searchControl);
    map.on('geosearch/showlocation', (result) => {
      const { x: lng, y: lat } = result.location;
      setMarkerPosition({ lat, lng });
      map.setView([lat, lng], 13);
    });

    return () => map.removeControl(searchControl);
  }, [setMarkerPosition]);

  return null;
}
export default GeoSearchBar